import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", full_name: "", phone: "", girone: "", password: "" });
  const [busy, setBusy] = useState(false);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.girone) return toast.error("Seleziona un girone");
    setBusy(true);
    const res = await register(form);
    setBusy(false);
    if (res.ok) {
      toast.success("Registrazione inviata! In attesa di approvazione dell'admin.");
      nav("/dashboard");
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="App">
      <Header />
      <div className="max-w-md mx-auto px-4 md:px-0 py-16 scale-in">
        <div className="card-surface rounded-3xl p-8 shadow-xl">
          <h1 className="display font-black text-3xl mb-2">Iscriviti</h1>
          <p className="text-slate-500 text-sm mb-6">La tua registrazione resta in <b>pending</b> finché l'Admin non approva.</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label className="text-slate-600">Email</Label>
              <Input required type="email" value={form.email} onChange={(e) => set("email", e.target.value)}
                     data-testid="register-email" className="bg-slate-50 border-slate-200 mt-1" />
            </div>
            <div>
              <Label className="text-slate-600">Nome e Cognome</Label>
              <Input required value={form.full_name} onChange={(e) => set("full_name", e.target.value)}
                     data-testid="register-fullname" className="bg-slate-50 border-slate-200 mt-1"
                     placeholder="Es. Mario Rossi" />
            </div>
            <div>
              <Label className="text-slate-600">Numero di telefono</Label>
              <Input required value={form.phone} onChange={(e) => set("phone", e.target.value)}
                     data-testid="register-phone" className="bg-slate-50 border-slate-200 mt-1"
                     placeholder="+39 ..." />
            </div>
            <div>
              <Label className="text-slate-600">Girone</Label>
              <Select value={form.girone} onValueChange={(v) => set("girone", v)}>
                <SelectTrigger data-testid="register-girone" className="bg-slate-50 border-slate-200 mt-1">
                  <SelectValue placeholder="Seleziona il tuo girone" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="A" data-testid="girone-A">Girone A</SelectItem>
                  <SelectItem value="B" data-testid="girone-B">Girone B</SelectItem>
                  <SelectItem value="C" data-testid="girone-C">Girone C</SelectItem>
                  <SelectItem value="D" data-testid="girone-D">Girone D</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label className="text-slate-600">Password</Label>
              <Input required type="password" minLength={6} value={form.password}
                     onChange={(e) => set("password", e.target.value)}
                     data-testid="register-password" className="bg-slate-50 border-slate-200 mt-1" />
            </div>
            <Button type="submit" disabled={busy} className="btn-brand w-full rounded-full h-11" data-testid="register-submit">
              {busy ? "Invio..." : "Iscriviti al torneo"}
            </Button>
          </form>
          <p className="text-slate-500 text-sm mt-6 text-center">
            Hai già un account?{" "}
            <Link to="/login" className="underline" style={{ color: "var(--brand)" }}>Accedi</Link>
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
